import primary from './primary'
import horizontal from './horizontal'
import horizontalAside from './horizontal-aside'
import horizontalLg from './horizontal-lg'
import horizontalHero from './horizontal-hero'
import horizontalMd from './horizontal-md'
import horizontalCover from './horizontal-cover'
import horizontalCoverWide from './horizontal-cover-wide'
import horizontalCoverHero from './horizontal-cover-hero'
import vertical from './vertical'
import verticalCover from './vertical-cover'
import paper from './paper'
import paperLg from './paper-lg'
import search from './search'
import interactive from './interactive'
import contact from './contact'
import sidebar from './sidebar'
import testimonial from './testimonial'
import cta from './cta'
import portfolio from './portfolio'
import sideprojects from './sideprojects'
import portfolioContent from './portfolio-content'
import article from './article'

const cards = {
  primary,
  horizontal,
  'horizontal-aside': horizontalAside,
  'horizontal-lg': horizontalLg,
  'horizontal-hero': horizontalHero,
  'horizontal-md': horizontalMd,
  'horizontal-cover': horizontalCover,
  'horizontal-cover-wide': horizontalCoverWide,
  'horizontal-cover-hero': horizontalCoverHero,
  vertical,
  'vertical-cover': verticalCover,
  paper,
  'paper-lg': paperLg,
  search,
  interactive,
  contact,
  sidebar,
  testimonial,
  cta,
  portfolio,
  sideprojects,
  portfolioContent,
  article
}

export default cards